import { all, put, race, select, take, takeEvery } from 'redux-saga/effects'
import { FAILED, SUCCESS } from 'crom-api-constants'
import _ from 'lodash'
import FileSaver from 'file-saver'
import contentDisposition from 'content-disposition'

import { getLocale, getToken } from '@global/selectors'

import IntlSaga from '../../../../../../services/translations/intl-saga'

import config from '../../../../../../config'

import { GET_EXPORT, GET_EXPORT_REQUEST, LOCALE_PREFIX, EXPORT_LOADER_ID } from './constants'

import { getExportRequest } from './actions'
import { showLoader, hideLoader } from '../../../../../../services/loader/actions'

import { error, success } from '../../../../../../services/toastr'

const GET_EXPORT_REQUEST_SUCCESS = (module, id, type) => `${GET_EXPORT_REQUEST(module, id, type)}_${SUCCESS}`
const GET_EXPORT_REQUEST_FAILED = (module, id, type) => `${GET_EXPORT_REQUEST(module, id, type)}_${FAILED}`

function* onGetExportSaga(_action) {
    const module = _.get(_action, 'data.module', null)
    const id = _.get(_action, 'data.id', null)
    const type = _.get(_action, 'data.type', null)
    if (!module || !id || !type) return null

    const params = _.get(_action, 'data.params', {})
    const outputName = _.get(_action, 'data.outputName', null)

    const locale = yield select(getLocale)
    yield put(showLoader(EXPORT_LOADER_ID, IntlSaga.formatMessage(locale, `${LOCALE_PREFIX}.loader`)))

    const token = yield select(getToken, id, module)

    const result = yield all({
        response: race({
            success: take(GET_EXPORT_REQUEST_SUCCESS(module, id, type)),
            failed: take(GET_EXPORT_REQUEST_FAILED(module, id, type)),
        }),
        request: put(getExportRequest[module](id, type, config.languages[locale].requestKey, token, params)),
    })

    yield put(hideLoader(EXPORT_LOADER_ID))

    const blob = _.get(result, 'response.success.payload.response.body', null)

    // default file name
    let fileName = `${module}_${id}_export.${type}`

    // if in action is outputName, use it
    if (outputName) fileName = `${outputName}.${type}`

    // if request contain attachment filename in content-disposition header, use it (higher priority than outputName)
    const contentDispositionHeader = _.get(
        result,
        'response.success.payload.response.headers.content-disposition',
        null
    )
    if (contentDispositionHeader) {
        const parsedHeader = contentDisposition.parse(contentDispositionHeader)
        const contentDispositionType = _.get(parsedHeader, 'type', null)
        const contentDispositionFilename = _.get(parsedHeader, 'parameters.filename', null)

        if (contentDispositionType === 'attachment' && contentDispositionFilename) fileName = contentDispositionFilename
    }

    if (result.response.failed || !blob) {
        error({ id: `${LOCALE_PREFIX}.error` })

        return null
    }

    FileSaver.saveAs(blob, fileName)
    success({
        id: `${LOCALE_PREFIX}.success`,
        values: { fileName },
    })

    return null
}

export default function* tabsSaga() {
    yield takeEvery(GET_EXPORT, onGetExportSaga)
}
